export default __webpack_public_path__ + "static/media/team.fecced45.jpeg";